import React, {useState, useEffect} from 'react';
import './Datasets.css';
import { observer } from 'mobx-react';
import Sidebar from '../../components/sidebar/index.js';
import Sidebar_new from '../../components/sidebar_for_user';
import Dataset from '../../components/dataset/index.js'
import Models from '../../components/models/index.js'
import GlobalState from "../../stores/GlobalState.js";
import PopupDeploymentAnalitics from '../../components/dataset/popup/popupDeploymentAnalitics.js';
import PopupAddDataset from '../../components/dataset/popup/popupAddDataset.js';
import PopupAttachment from '../../components/dataset/popup/popupAttachment.js';
import PopupDeleteDataset from '../../components/dataset/popup/popupDeleteDataset';
import PopupRefreshDataset from '../../components/dataset/popup/popupRefreshDataset';
import PopupRefreshDatasetCSV from '../../components/dataset/popup/popupRefreshDatasetCSV';
import {Helmet} from "react-helmet";
import Mini from '../../components/mini/index.js'
import UserPool from '../../components/autorize/UserPool';


const Datasets= observer(() => {
    const [holdBlock, setholdBlock] = useState(true);
    const [datasegment, setDatasegment] = useState(1);
    const changemenu = () =>{
        setholdBlock(false)
    }
    window.onbeforeunload = () => {
        setholdBlock(true)
    }
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [user, setUser]=useState("");
    const token = localStorage.getItem("token");
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            const cognitoUser = UserPool.getCurrentUser();
            setUser(cognitoUser.username)
        } 
    }, []);
    return (
        <>
        {
            langmenu=="de"?
            <Helmet>
                <title>Beinf.ai — Hochladen historischer Datensätze</title>
                <meta name="description" content="Mit Beinf.ai ist es einfach, Kundendaten in wertvolle Business-Insights zu verwandeln. Lade deinen Datensatz für die weitere Analyse hoch." />
            </Helmet>
            :
            <Helmet>
                <title>Beinf.ai — Uploading Historical Datasets</title>
                <meta name="description" content="With Beinf.ai, it's easy to turn customer datasets into valuable business insights. Upload your dataset for further analysis." />
            </Helmet>
        }
        {
            
            user=="admin"|| user=="gewgur"?
            <>
                <Sidebar_new/>
            </>
            :
            <>
                <Sidebar/>
            </>
        }
        
        <div className="segmentation models hold">
           
            <div className='body_segment'>
                <Dataset/>
            </div>
        </div>
        <Mini/>
        {GlobalState.ispopupaddAttachmentShowAnalitics?<PopupDeploymentAnalitics/>:<></>}
        {GlobalState.ispopupadddatasetShow?<PopupAddDataset/>:<></>}
        {GlobalState.ispopupaddAttachmentShow?<PopupAttachment/>:<></>}
        {GlobalState.ispopupdeleteDatasetShow ?<PopupDeleteDataset id={GlobalState.ispopupdeletedatasetid} deleteIdnum = {GlobalState.ispopupdeleteatasetname}/>:<></>}
        {GlobalState.ispopuprefreshDatasetShow ?<PopupRefreshDataset id={GlobalState.ispopupdeletedatasetid} deleteIdnum = {GlobalState.ispopupdeleteatasetname}/>:<></>}
        {GlobalState.ispopuprefreshDatasetShowcsv ?<PopupRefreshDatasetCSV id={GlobalState.ispopupdeletedatasetid} deleteIdnum = {GlobalState.ispopupdeleteatasetname}/>:<></>}
        </>
    );
})

export default Datasets;

